import firebase from '../firebase/firebase';
import _ from 'lodash';
import {
    BULK_SET_PLACEHOLDER,
    FETCH_EVENTS_LOADING,
    FETCH_LOCATIONS_LOADING,
    FETCH_EVENTS_SUCCESS,
    FETCH_LOCATIONS_SUCCESS,
    UPDATE_MARKER,
    MOVE_MARKERS,
    SET_CENTER,
    TOGGLE_OVERLAY,
    EDIT_MARKER,
    BULK_EDIT_MARKER,
    SET_ACTIVE_MARKER,
    SET_EVENT_ID,
    OMIT_QUESTION,
    SET_TEMPLATE,
    SET_START_DATE,
    GET_PLACEHOLDERS,
    SET_PLACEHOLDERS,
    SET_BACKGROUND_IMAGE,
    RESET_MARKER_KEY,
    SET_IMAGE_CAROUSEL,
    FETCH_IMAGES_SUCCESS,
    FETCH_IMAGES_FAIL,
    FETCH_IMAGES_LOADING,
    TRANSLATE_LOADING,
    TRANSLATE_FAIL,
} from '../actions/types';

const INITIAL_STATE = {
    eventName: 'This city',
    key: '',
    template: {},
    placeholders: {},
    loading: false,
    gameIds: [],
    eventTemplates: [],
    userEvents: [],
    locations: {},
    showOverlay: false,
    showImageCarousel: false,
    fetchImageLoading: false,
    translateLoading: false,
    imageUrls: [],
};

const EventsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_BACKGROUND_IMAGE:
            return { ...state, template: { ...state.template, backgroundImage: action.payload } }
        case RESET_MARKER_KEY:
            return { ...state, key: '', }
        case FETCH_EVENTS_LOADING:
            return { ...state, loading: true }
        case FETCH_EVENTS_SUCCESS:
            return { ...state, loading: false, eventTemplates: action.payload.eventTemplates, userEvents: action.payload.userEvents }
        case FETCH_LOCATIONS_SUCCESS:
            return { ...state, loading: false, locations: action.payload }
        case FETCH_LOCATIONS_LOADING:
            return { ...state, loading: true }
        case SET_EVENT_ID:
            return { ...state, template: { ...state.template, id: action.payload } }
        case SET_START_DATE:
            return { ...state, template: { ...state.template, startTime: firebase.firestore.Timestamp.fromDate(new Date(action.payload)) } }
        case GET_PLACEHOLDERS:
            return { ...state, placeholders: action.payload, }
        case SET_PLACEHOLDERS:
            return { 
                ...state, 
                placeholders: { 
                    ...state.placeholders, 
                    [action.payload.markerKey]: {
                        ...state.placeholders[action.payload.markerKey],
                        [action.payload.placeholderKey]: action.payload.value,
                    } 
                } }
        case SET_TEMPLATE:
            return { ...state, template: action.payload, }
        case EDIT_MARKER: {
            const { prop, text, key } = action.payload;
            return { 
                ...state, 
                locations: { ...state.locations, [key]: { ...state.locations[key], [prop]: text } }
            }
        }
        case BULK_EDIT_MARKER: {
            const { value, key } = action.payload;
            return { 
                ...state, 
                locations: { ...state.locations, [key]: { ...state.locations[key], ...value } },
                translateLoading: false 
            }    
        }
        case OMIT_QUESTION: {
            const { key, keys } = action.payload;
            return { 
                ...state, 
                locations: { ...state.locations, [key]: _.omit(state.locations[key], keys) } 
            } 
        }
        case TOGGLE_OVERLAY:
            return { ...state, showOverlay: action.payload }
        case SET_ACTIVE_MARKER: {
            return { ...state, key: action.payload, }
        }
        case UPDATE_MARKER: {
            const { key, lat, lng } = action.payload;
            const locations = {
                ...state.locations,
                [key]: {
                    ...state.locations[key],
                    coordinates: new firebase.firestore.GeoPoint(lat, lng)
                }
            }
            return { ...state, locations, }
        }
        case MOVE_MARKERS: {
            const { lat, lng } = action.payload;
            const referenceMarker = state.locations[Object.keys(state.locations)[0]];
            let locations = { ...state.locations };

            Object.entries(locations).forEach(([key, value]) => {
                const new_lat = lat - (referenceMarker.coordinates.latitude - value.coordinates.latitude)
                const new_lng = lng - (referenceMarker.coordinates.longitude - value.coordinates.longitude)

                if (new_lat > -90 && new_lat < 90 && new_lng < 180 && new_lng > -180) {
                    locations[key] = {
                        ...value,
                        coordinates: new firebase.firestore.GeoPoint(new_lat, new_lng)
                    }
                }
            })

            return { ...state, locations, }
        }
        case SET_CENTER:
            return { ...state, center: action.payload, }
        case SET_IMAGE_CAROUSEL:
            return { ...state, showImageCarousel: action.payload, }
        case FETCH_IMAGES_SUCCESS:
            return { ...state, imageUrls: action.payload, fetchImageLoading: false }
        case FETCH_IMAGES_FAIL:
            return { ...state, imageUrls: [], fetchImageLoading: false }
        case FETCH_IMAGES_LOADING:
            return { ...state, fetchImageLoading: true }
        case TRANSLATE_LOADING:
            return { ...state, translateLoading: true, }
        case TRANSLATE_FAIL:
            return { ...state, translateLoading: false, }
        case BULK_SET_PLACEHOLDER: 
            return { 
                ...state, 
                translateLoading: false,
                placeholders: { 
                    ...state.placeholders, 
                    [action.payload.markerKey]: action.payload.placeholders
                }}
        default:
            return state;
    }
};

export default EventsReducer;